import { AxiosResponse, CancelToken } from 'axios'
import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'
import { ProfileInterface } from '../../../../interface/profile.interface'

export const getAccountsProfileService = (
  cancelToken?: CancelToken,
): Promise<AxiosResponse<ProfileInterface>> =>
  apiInstance.get(ApiPathConfig.ACCOUNTS_PROFILE, { cancelToken })
